// URL DE AMBIENTE APIBPM
const urlEnviroment = 'https://app-sds-transportabilidad-release-eastus.azurewebsites.net/';

export const environment = {
  production: false,

    urlAPI: `${urlEnviroment}api`,

    //variables para Azure AD
    baseUrl: `${urlEnviroment}api/`,
    postLogoutUrl: '/',
    APP_CLIENT_ID : '6bb62c43-b835-4471-aef2-4fbaf120ef64',
    APP_AUTHORITY : 'https://saludcapitalb2c.b2clogin.com/saludcapitalb2c.onmicrosoft.com/B2C_1_InicioSesionConRegistro',
    APP_REDIRECT_TO : '/',
    APP_ROL_URL: 'Ciudadano.Read',      
};